const useStyles = theme => ({
    container: {
      position: 'relative',
    },
    playButtonArrow: {
      fontSize: 25,
      [theme.breakpoints.only('md')]: {
        fontSize: 30,
      },
      [theme.breakpoints.down('sm')]: {
        fontSize: 15,
      },
    },
    previewImage: {
      objectFit: 'cover',
      height: '100%',
      width: '100%'
    },
    durationBox: {
      bottom: '5px',
      right: '5px',
      position: 'absolute',
    },
    gradientBox: {
      opacity: 0.3,
      zIndex: 0,
      position: 'absolute',
      height: '100%',
      width: '100%',
      background: 'linear-gradient(to bottom, rgba(0,0,0,0.1), black)',
    },
    playButton: {
      position: 'absolute',
      height: '45px',
      width: '45px',
      borderRadius: 30,
      [theme.breakpoints.down('sm')]: {
        height: '25px',
        width: '25px',
      },
    },
});

export default useStyles
